import styled from '@emotion/styled';
import { useState } from 'react';
import Close from 'svg/close.svg?react';

const ManagementLoginModal = ({ onClose, onSuccess }) => {
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = () => {
    if (password === '124124') {
      onSuccess();
    } else {
      setErrorMessage('비밀번호가 일치하지 않거나, 권한이 없습니다.');
    }
  };

  return (
    <ModalOverlay>
      <ModalWrapper>
        <Title>관리자 비밀번호 입력</Title>
        <Content>6자리 숫자로 이루어진 관리자 비밀번호를 입력해주세요.</Content>

        <InputGroup>
          <input
            type="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            placeholder="비밀번호 입력"
            maxLength={6}
          />
          <Button onClick={handleSubmit} disabled={password.length !== 6}>
            입력 완료
          </Button>
        </InputGroup>
        {errorMessage !== '' && <ErrorMessage>{errorMessage}</ErrorMessage>}

        <StyledClose onClick={onClose} />
      </ModalWrapper>
    </ModalOverlay>
  );
};

export default ManagementLoginModal;

const ErrorMessage = styled.p`
  ${({ theme }) => theme.typography.REGULAR_12};
  color: ${({ theme }) => theme.color.warningRed};
`;

const InputGroup = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  gap: 20px;
  margin-bottom: 8px;

  > input {
    width: 340px;
    height: 72px;
    border-radius: 12px;
    border: solid 1px #252b39;
    text-align: center;
    ${({ theme }) => theme.typography.REGULAR_24}
    color: #252b39;

    &::placeholder {
      ${({ theme }) => theme.typography.REGULAR_24}
      color: #b2b7c4;
      text-align: center;
    }

    &:disabled {
      background-color: #e6e8ef;
    }
  }
`;

const Button = styled.button`
  width: 128px;
  height: 72px;
  text-align: center;
  white-space: nowrap;
  border-radius: 12px;
  ${({ theme }) => theme.typography.REGULAR_24}
  background: #353c4d;
  color: #cdd1dd;

  &:disabled {
    cursor: not-allowed;
    background: #cdd1dd;
    color: #b2b7c4;
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
`;

const ModalWrapper = styled.div`
  position: relative;
  width: 525px;
  height: 258px;
  display: flex;
  flex-direction: column;
  padding: 28px 24px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.color[2]};
  box-shadow: 4px 4px 15px 0px #00000040;
`;

const StyledClose = styled(Close)`
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;
`;

const Title = styled.p`
  ${({ theme }) => theme.typography.SEMI_BOLD_24};
  color: #151619;
  margin-bottom: 12px;
`;

const Content = styled.p`
  ${({ theme }) => theme.typography.MEDIUM_16};
  color: #252b39;
  margin-bottom: 40px;
`;
